import * as React from 'react';
import { PrimaryButton } from '@magoosh/lib/button';
import { adminPaths } from 'config/path_helpers';
import fetch from 'utilities/fetch';

interface FormProps {
  mtt: any;
  runQuery: any;
  closeModal: () => void;
}

const MTTResetForm: React.FC<FormProps> = (props) => {
  const submitForm = () => {
    fetch(adminPaths.api.resetModuleTrackTemplate(props.mtt.id), {
      method: 'POST',
    })
      .then((response) => {
        props.closeModal();
        props.runQuery();
      })
      .catch((response) => alert(response.errors._error));
  };

  return (
    <div>
      <p>
        <p>Reset <b>{props.mtt.containerBlock.name}</b>?</p>
      </p>
      <PrimaryButton className="u-margin-T-s" onClick={() => submitForm()}>
        Ok
      </PrimaryButton>
    </div>
  );
};

export default MTTResetForm;
